require('bootstrap');
require('popper.js').default;
require('moment');
// import moment from '../lib/moment-with-locales.min.js';

require('../lib/modernizr-custom.js');
require('../lib/jquery.input-stepper.js');
require('../lib/bootstrap-datepicker/js/bootstrap-datepicker.js');
require('../lib/pickadate3/picker.js');
require('../lib/pickadate3/picker.date.js');
require('../lib/pickadate3/translations/th_TH.js');
//require('../lib/bootstrap-datepicker-mobile.js');

var options = {};
$(document).ready(function(){

    $('#mobile-product-nav-toggle').click(function(){
        $(this).toggleClass('active');
        $('#mobile-product-nav').toggleClass('active');
    });

    $('#mobile-product-nav > .product-nav-category > .product-nav-dropdown-toggle').click(function(e){
        e.preventDefault();
        $(this).closest('.product-nav-category').toggleClass('active');
    });

    $('.product-nav-dropdown-back').click(function(e){
        e.preventDefault();
        $(this).closest('.product-nav-category').removeClass('active');
    });

	$('.datepicker-end').pickadate({
		min: new Date()
		/*
		title: "วันที่คืนของ",
		format: "dd/mm/yyyy",
		autoclose: true,
		todayHighlight: true,
		startDate: '+0d',
		language: 'th',
    focusOnShow: false,
    ignoreReadonly: true,
    disableTouchKeyboard: true
    */
	});

	$('.datepicker-start').pickadate({
		min: new Date()
		/*
		title: "วันที่รับของ",
		format: "dd/mm/yyyy",
		autoclose: true,
		todayHighlight: true,
		startDate: '+0d',
		language: 'th',
    focusOnShow: false,
    ignoreReadonly: true,
    disableTouchKeyboard: true
    */
	});

	$(document).on('click','.social-login',function(e){
		e.preventDefault();
		var url = $(this).attr('href');
		window.open(url,"popname", "status=1, height=450, width=450, toolbar=0");
		return false;
	});

    $('.product-form').submit(function(e){
        e.preventDefault();
        // console.log('form-submit');
        addCart($(this).serialize());
        return false;
    });

	// $('.order-add-cart').click(function(){
	// 	var $parent = $(this).closest('.product-form');
	// 	addCart($parent.serialize());
	// });

	$('.order-checkout').click(function(){
		var $parent = $(this).closest('.product-form');
		addCart($parent.serialize(),true);
	});

	$('.input-stepper').inputStepper();

	$('#cart-header').click(function(){
		showCart();
	});
	$('#cart-floating').click(function(){
		showCart();
	});

	$('.quickfind-type').change(function(){
		var $parent = $(this).closest('.quickfind-form');
		updateType({type:$(this).val()},$parent);
	});

	/*
	$('#cart-header').click(function(){
		showLoading();
		loadCart(function(html){
			var $cart_dialog = $(html);
			initCart( $('.cart',$cart_dialog) );
			hideLoading();
			$cart_dialog.modal('show');
		});
	});

	$('.cart').each(function(){
		initCart($(this));
	});
	*/

	$('.product-form input, .product-form select').change(function(){
		var $parent = $(this).closest('.product-form');
		updatePrice($parent.serialize());
	});
	$('.product-form').each(function(){
		updatePrice($(this).serialize());
	});


	$('.product-view-downpayment').click(function(){
		var $this = $(this);
		//console.log('test');
		showLoading();
		$.ajax({
			type: "GET",
			url: '/ajax/show-down-payment/'+$this.data('id'),
			success: function(data)
			{
				if(data)
				{
					setTimeout(function(){
						var $dialog = $(data);
						hideLoading();
						initJS($dialog)
						$dialog.modal('show');

					}, 100);
				} else {
					alert('An Error Occure');
				}
			},
			error: function(err) {
				alert('An Error Occure');
			}
		});
	});
});

function initJS( $data )
{
	$('[data-toggle="tooltip"]',$data).tooltip()
}

function updateType( data, $parent )
{
	$.ajax({
		type: "POST",
		url: '/ajax/update-type',
		data: data,
		dataType: "json",
		success: function(data)
		{
			if(data)
			{
				$('.quickfind-category',$parent).empty();
				$('.quickfind-category',$parent).append($('<option>', { value : "" }).text(data.type_name+"ทุกประเภท"));
				$.each(data.categories, function(key, value) {
					$('.quickfind-category',$parent).append($('<option>', { value : key }).text(value));
				});
			} else {
				alert('An Error Occure');
			}
		},
		error: function(err) {
			alert('An Error Occure');
		}
	});
}

function updatePrice( formdata )
{
	$.ajax({
		type: "POST",
		url: '/ajax/update-price',
		data: formdata,
		dataType: "json",
		success: (data)=>
		{
			if(data)
			{
				$('.calc-day').text(data.day);
				if(data.discount)
				{
					$('.calc-price-strike').text(data.price);
					$('.calc-price').text(data.discount);
				} else {
					$('.calc-price-strike').text("");
					$('.calc-price').text(data.price);
				}
				if(data.available>0 && data.day>0){
					if( data.holiday ) {
						$('.calc-availabity').removeClass('available');
						$('.calc-availabity').removeClass('unknown');
						$('.calc-availabity').text(data.holiday);
						$('.product-cart-buttons').addClass('hidden');
						$('.product-price-wrapper').addClass('hidden');
						$('.product-view-downpayment').addClass('hidden');
                    } else if( data.allow_location === false ) {
                        $('.calc-availabity').removeClass('available');
                        $('.calc-availabity').removeClass('unknown');
                        $('.calc-availabity').text(data.disallow_location_text);
                        $('.product-cart-buttons').addClass('hidden');
                        $('.product-price-wrapper').addClass('hidden');
                        $('.product-view-downpayment').addClass('hidden');
					} else {
						$('.calc-availabity').addClass('available');
						$('.calc-availabity').removeClass('unknown');
						$('.calc-availabity').text("ว่าง  - รวม "+data.day+" วัน ");

                        if(data.amount > data.available) {
                            alert('จำนวนสินค้าไม่เพียงพอ');
                            $('.order-amount').val(data.available);
                        }
                        // $('.order-amount').attr('max',data.available);
                        // $('.input-stepper',$('.product-cart-buttons')).inputStepper()

						$('.product-cart-buttons').removeClass('hidden');
						$('.product-price-wrapper').removeClass('hidden');
						$('.product-view-downpayment').removeClass('hidden');
					}
				} else if(data.day>0) {
					$('.calc-availabity').removeClass('available');
					$('.calc-availabity').removeClass('unknown');
					$('.calc-availabity').text("ไม่ว่าง");
					$('.product-cart-buttons').addClass('hidden');
					$('.product-price-wrapper').addClass('hidden');
					$('.product-view-downpayment').removeClass('hidden');
				} else {
					$('.calc-availabity').removeClass('available');
					$('.calc-availabity').addClass('unknown');
					$('.calc-availabity').text("กรุณาเลือกวันเวลาที่ต้องการยืม-คืน");
					$('.product-cart-buttons').addClass('hidden');
					$('.product-price-wrapper').addClass('hidden');
					$('.product-view-downpayment').addClass('hidden');
				}
			} else {
				alert('An Error Occure');
			}
		},
		error: function(err) {
			alert('An Error Occure');
		}
	});
}

function showLoading()
{
	$('#global-loading').addClass('active');
}

function hideLoading()
{
	$('#global-loading').removeClass('active');
}

function showCart()
{
	showLoading();
	loadCart(function(html){
		var $cart_dialog = $(html);
		initCart( $('.cart',$cart_dialog) );
		hideLoading();
		$cart_dialog.modal('show');
	});
}

function loadCart( callback )
{
	$.ajax({
		type: "GET",
		url: '/ajax/get-cart-dialog',
		success: function(data)
		{
			if(data)
			{
				setTimeout(function(){
					callback(data);
				}, 100);
			} else {
				alert('An Error Occure');
			}
		},
		error: function(err) {
			alert('An Error Occure');
		}
	});
}

function initCart( $cart )
{
	// Init Plugins
	$('.input-stepper', $cart).inputStepper();

	$('.cart-item-amount', $cart).change(function(){
		var $parent = $(this).closest('.cart-product-row');
		var item_id = $parent.data('id');
		var $this = $(this);

		updateCart( item_id, $(this).val(), function( data ){
			//console.log(amount);
			if(data.is_delete)
			{
				$parent.remove();
			} else {
				$this.val(data.amount);
                // console.log(inp)
                // $('.input-stepper', $parent).inputStepper('destroy')
                // $('.input-stepper', $parent).inputStepper().getValue()
                // console.log($('.input-stepper', $parent).first().inputStepper().getValue())
			}
			calCart($parent.closest('.cart'));
		});
	});

	$('.cart-delete-button', $cart).click(function(){
		if(!confirm('Confirm Delete?'))return;

		var $parent = $(this).closest('.cart-product-row');
		var item_id = $parent.data('id');

		$parent.addClass('deleted');

		removeCart(item_id,function(){$parent.remove()});
		return false;
	});

	calCart( $cart );
}


function calCart( $cart )
{
	var grand_total = 0;
	$('.cart-product-row',$cart).each(function(){
		var $parent = $(this);
		var item_price = $('.cart-item-price',$parent).text();
		var amount = $('.cart-item-amount',$parent).val();
		//console.log(item_price);
		//console.log(amount);
		var line_price = parseInt( item_price ) * parseInt( amount );
		grand_total += line_price;
		$('.cart-line-price',$parent).text( line_price.toLocaleString() );
	});
	$('.cart-grand-total',$cart).text(grand_total.toLocaleString());
}


function addCart(data, checkout = false)
{
	$.ajax({
		type: "POST",
		url: '/ajax/add-cart',
		data: data,
		dataType: "json",
		success: function(data)
		{
			if(data)
			{
				if(data.success)
				{
					if(checkout){
						window.location = '/order/checkout';
					} else {
						$('#cart-header-amount').text(data.new_amount);
						showCart();
					}
				} else {
					alert(data.message)
				}
			} else {
				alert('An Error Occure');
			}
		},
		error: function(err) {
			alert('An Error Occure');
		}
	});
}

function removeCart( item_id, callback )
{
	$.ajax({
		type: "POST",
		url: '/ajax/remove-cart',
		data: {item_id:item_id},
		dataType: "json",
		success: function(data)
		{
			if(data && data.success==1)
			{
				setTimeout(function(){
					callback();
				}, 300);
			} else {
				alert('An Error Occure');
			}
		},
		error: function(err) {
			alert('An Error Occure');
		}
	});
}

function updateCart( item_id, amount, callback )
{
	$.ajax({
		type: "POST",
		url: '/ajax/update-cart',
		data: {item_id:item_id,amount:amount},
		dataType: "json",
		async: true,
		success: function(data)
		{
			if(data)
			{
				if(data.success)
				{
					setTimeout(function(){
						callback(data);
					}, 300);
				} else {
					setTimeout(function(){
						callback(data);
					}, 300);
					alert(data.message)
				}
			} else {
				alert('An Error Occure');
			}
		},
		error: function(err) {
			alert('An Error Occure');
		}
	});
}



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/app.js